module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/crud-companias/crud-companias.component.css
// module id = ./src/app/crud-companias/crud-companias.component.css
// module chunks = main